import { client } from '../client';
import { Insurance } from './types/UserProfile';

export const deactivateInsuranceById = async (insuranceId: number): Promise<Insurance> => {
  const { data } = await client.put<Insurance>(`/insurances/${insuranceId}/deactivate`);
  return data;
};
